import React from 'react'
import { Routes, Route } from 'react-router-dom'

import SolanaNFTPage from 'pages/solana-nft'
import NotFoundPage from 'pages/not-found'
import LoginPage from 'pages/auth/login'
import SolanaVolumeCheck from 'pages/solana-volume-check'

import ProtectedRoutes from './protected-routes'
import PublicRoutes from './public-routes'
import TrendingCollectionsPage from 'pages/trending-collections'
import AdminSettingsPage from 'pages/admin-settings'
import AddNewNFTPage from 'pages/add-new-nft'
import DiscordServers from 'pages/discord-servers'
import ChatReports from 'pages/chat-reports'
import NewsArticles from 'pages/news-articles'
import DuplicateNFTs from 'pages/duplicate-nfts'
import TestEnvironmentPage from 'pages/test-environment'
import LiveNewsFeedPage from 'pages/live-news-feed'
import LastUpdatedPage from 'pages/last-updated-check'
import FlaggedNftCollectionsPage from 'pages/flagged-collections'
import RequestedNftCollectionsPage from 'pages/requested-collections'
import LastUpdatedListingsPage from 'pages/last-updated-check-listings'
import UserFeedbackPage from 'pages/user-feedback'
import OverviewPage from 'pages/overview'

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<ProtectedRoutes />}>
        <Route path='/' element={<OverviewPage />} />
        <Route path='/overview' element={<OverviewPage />} />
        <Route path='/invalid-solana-nfts' element={<SolanaNFTPage />} />
        <Route path='/trending-collections' element={<TrendingCollectionsPage />} />
        <Route path='/discord-servers' element={<DiscordServers />} />
        <Route path='/add-new-nft' element={<AddNewNFTPage />} />
        <Route path='/admin-settings' element={<AdminSettingsPage />} />
        <Route path='/solana-volume-check' element={<SolanaVolumeCheck />} />
        <Route path='/chat-reports' element={<ChatReports />} />
        <Route path='/news-articles' element={<NewsArticles />} />
        <Route path='/duplicate-nfts' element={<DuplicateNFTs />} />
        <Route path='/test-environment' element={<TestEnvironmentPage />} />
        <Route path='/live-news-feed' element={<LiveNewsFeedPage />} />
        <Route path='/last-updated' element={<LastUpdatedPage />} />
        <Route path='/last-updated-listings' element={<LastUpdatedListingsPage />} />
        <Route path='/flagged-collections' element={<FlaggedNftCollectionsPage />} />
        <Route path='/requested-collections' element={<RequestedNftCollectionsPage />} />
        <Route path='/user-feedback' element={<UserFeedbackPage />} />
      </Route>

      <Route path='login' element={<PublicRoutes />}>
        <Route path='/login' element={<LoginPage />} />
      </Route>

      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}

export default AppRoutes
